import { z, uuidSchema } from '@kc3/validation';
const CHATBOT_FLOW_STATUSES = ['active', 'inactive'];
export const TERMINAL_ACTIONS = ['none', 'escalate', 'message', 'end'];
export const FlowOptionSchema = z.object({
    id: z.string().min(1),
    label: z.string(),
    targetQuestionId: z.string().min(1),
});
export const FlowQuestionSchema = z.object({
    id: z.string().min(1),
    text: z.string().max(4096),
    options: z.array(FlowOptionSchema).default([]),
    terminalAction: z.enum(TERMINAL_ACTIONS).default('none'),
});
export const ChatbotFlowSchema = z.object({
    startQuestionId: z.string().min(1),
    questions: z.record(z.string(), FlowQuestionSchema),
});
export const ChatbotFlowConfigurationSchema = z.object({
    id: uuidSchema,
    tenantId: uuidSchema,
    status: z.enum(CHATBOT_FLOW_STATUSES),
    draftFlow: ChatbotFlowSchema,
    publishedFlow: ChatbotFlowSchema,
    publishedAt: z.string().datetime().nullable(),
    updatedAt: z.string().datetime(),
    updatedBy: uuidSchema.nullable(),
});
export const UpdateChatbotFlowDraftRequestSchema = z.object({
    flow: ChatbotFlowSchema,
});
export const EMPTY_CHATBOT_FLOW = {
    startQuestionId: 'q1',
    questions: {
        q1: { id: 'q1', text: '', options: [], terminalAction: 'none' },
    },
};
//# sourceMappingURL=chatbot-flow.js.map